import { Subject } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as fromMenus from '../../base/reducers';
var MenuControlService = /** @class */ (function () {
    function MenuControlService(store) {
        this.store = store;
        this.triggerSubject = new Subject();
        this.activeAccordionId = new Subject();
        this.activeAccordionChain = new Subject();
        this.sideMenuItems$ = this.store.pipe(select(fromMenus.getSideMenuList));
    }
    Object.defineProperty(MenuControlService.prototype, "trigger$", {
        get: function () {
            return this.triggerSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    MenuControlService.prototype.trigger = function (id) {
        this.triggerSubject.next(id);
    };
    MenuControlService.prototype.setActiveAccordion = function (id) {
        this.activeAccordionId.next(id);
    };
    return MenuControlService;
}());
export { MenuControlService };
